import axiosInstance from './axiosInstance';
import config from '../config';
import { StockCount, CreateStockCountDto, UpdateStockCountDto } from '../types/stockCounts.types';

const API_URL = `${config.API_BASE_URL}/StockCounts`;

export const stockCountsService = {
  getAll: async (
    status?: string,
    warehouseId?: number,
    branchId?: number,
    fromDate?: string,
    toDate?: string
  ): Promise<StockCount[]> => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (warehouseId) params.append('warehouseId', warehouseId.toString());
    if (branchId) params.append('branchId', branchId.toString());
    if (fromDate) params.append('fromDate', fromDate);
    if (toDate) params.append('toDate', toDate);

    const url = params.toString() ? `${API_URL}?${params.toString()}` : API_URL;
    const response = await axiosInstance.get<StockCount[]>(url);
    return response.data;
  },

  getById: async (id: number): Promise<StockCount> => {
    const response = await axiosInstance.get<StockCount>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (stockCount: CreateStockCountDto): Promise<StockCount> => {
    const response = await axiosInstance.post<StockCount>(API_URL, stockCount);
    return response.data;
  },

  update: async (id: number, stockCount: UpdateStockCountDto): Promise<StockCount> => {
    const response = await axiosInstance.put<StockCount>(`${API_URL}/${id}`, stockCount);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  approve: async (id: number): Promise<StockCount> => {
    const response = await axiosInstance.post<StockCount>(`${API_URL}/${id}/approve`);
    return response.data;
  },

  unapprove: async (id: number): Promise<StockCount> => {
    const response = await axiosInstance.post<StockCount>(`${API_URL}/${id}/unapprove`);
    return response.data;
  },

  post: async (id: number): Promise<StockCount> => {
    const response = await axiosInstance.post<StockCount>(`${API_URL}/${id}/post`);
    return response.data;
  },

  unpost: async (id: number): Promise<StockCount> => {
    const response = await axiosInstance.post<StockCount>(`${API_URL}/${id}/unpost`);
    return response.data;
  },

  generateCountNumber: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-count-number`);
    return response.data;
  },
};